/** Matches campaign FlowPathsPanel / FlowWeightedItemRow list container. */
export const PATH_LIST_CONTAINER_CLASS =
  'divide-y divide-border/40 rounded-md border border-border/50 bg-background/30';
